export const formatLoyaltyPoints = (points, displayType) => {
    if (displayType === 'POINTS') {
      return `${points.toLocaleString()} points`;
    } else if (displayType === 'DOLLARS') {
      const dollars = points / 100;
      return `$ ${dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    } else {
      throw new Error("Invalid display type. Use 'POINTS' or 'DOLLARS'.");
    }
  };